function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ICON/SETTINGS",
  transform: "translate(-2.000000, -2.000000)"
}, React.createElement("g", null, React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), React.createElement("path", {
  d: "M19.14,12.936 C19.176,12.636 19.2,12.324 19.2,12 C19.2,11.676 19.176,11.364 19.128,11.064 L21.156,9.48 C21.336,9.336 21.384,9.072 21.276,8.868 L19.356,5.544 C19.236,5.328 18.984,5.256 18.768,5.328 L16.38,6.288 C15.876,5.904 15.348,5.592 14.76,5.352 L14.4,2.808 C14.364,2.568 14.16,2.4 13.92,2.4 L10.08,2.4 C9.84,2.4 9.648,2.568 9.612,2.808 L9.252,5.352 C8.664,5.592 8.124,5.916 7.632,6.288 L5.244,5.328 C5.028,5.244 4.776,5.328 4.656,5.544 L2.736,8.868 C2.616,9.084 2.664,9.336 2.856,9.48 L4.884,11.064 C4.836,11.364 4.8,11.688 4.8,12 C4.8,12.312 4.824,12.636 4.872,12.936 L2.844,14.52 C2.664,14.664 2.616,14.928 2.724,15.132 L4.644,18.456 C4.764,18.672 5.016,18.744 5.232,18.672 L7.62,17.712 C8.124,18.096 8.652,18.408 9.24,18.648 L9.6,21.192 C9.648,21.432 9.84,21.6 10.08,21.6 L13.92,21.6 C14.16,21.6 14.364,21.432 14.388,21.192 L14.748,18.648 C15.336,18.408 15.876,18.084 16.368,17.712 L18.756,18.672 C18.972,18.756 19.224,18.672 19.344,18.456 L21.264,15.132 C21.384,14.916 21.336,14.664 21.144,14.52 L19.14,12.936 L19.14,12.936 Z M12,15.6 C10.02,15.6 8.4,13.98 8.4,12 C8.4,10.02 10.02,8.4 12,8.4 C13.98,8.4 15.6,10.02 15.6,12 C15.6,13.98 13.98,15.6 12,15.6 Z",
  id: "Shape",
  fillRule: "nonzero"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/settings_2.c6d89fa0.svg";
export { SvgComponent as ReactComponent };